class KitSelector {
  constructor(element) {
    this.section = element;
    this.form = this.section.querySelector('[data-kit-form]');
    
    if (!this.form) {
      console.error('Kit form not found');
      return;
    }

    document.addEventListener("theme:partner:set", (event) => {
      this.partner = event.detail.partner;
    });

    this.kitButton = this.section.querySelector('[data-business-kit-add]');
    if (!this.kitButton) {
      console.error('Kit button not found');
      return;
    }

    this.checkCart();
    
    this.kitButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.checkCartAndInitialize();
    });
    
    // Get and log customer data
    this.initCustomerData();

    // Check if customer is a consultant and disable buttons if true
    if (this.isConsultant()) {
      this.disableKitButton();
    }
  }

  disableKitButton() {  
    this.kitButton.disabled = true;
    this.kitButton.classList.add('disabled');
    this.kitButton.textContent = window.theme.strings.enrollmentNotAllowed;
  }

  initCustomerData() {
    try {
      const customerDataElement = this.section.getAttribute('data-customer');
      if (customerDataElement && customerDataElement !== 'null') {
        // Decode HTML entities and parse JSON
        const decodedData = customerDataElement
          .replace(/&quot;/g, '"')
          .replace(/&#39;/g, "'")
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&amp;/g, '&');
        
        const customer = JSON.parse(decodedData);
        this.customer = customer;
      } else {
        console.log('Customer not logged in');
        this.customer = null;
      }
    } catch (error) {
      console.error('Error parsing customer data:', error);
      console.log('Raw customer data:', this.section.getAttribute('data-customer'));
      this.customer = null;  
    }
  }

  async checkCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const kitVariantId = this.form.querySelector('[name="id"]').value;
      console.log(kitVariantId,'kitVariantId');
      const kitInCart = cart.items.find(item => 
        item.variant_id.toString() === kitVariantId
      );

      if (kitInCart) {
        this.disableKitButton();
      }
    } catch (error) {
      console.error('Error checking cart:', error);
    }
  }
  updateHeaderTotal() { 
        return fetch(`${window.theme.routes.cart}.js`).then((response)=>{
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
              detail: {
                  cart: response.data
              },
              bubbles: true
          }));
      }).catch((e)=>{
          console.error(e);
      });
    }

  async checkCartAndInitialize() {
    this.checkCart().then(async () => {
     
        // Disable button and show loading state
        this.kitButton.disabled = true;
        this.kitButton.textContent = 'Adding to cart...';
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({
              id: this.kitButton.dataset.variantId,
              quantity: 1
          })
        })
        
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          this.kitButton.textContent = window.theme.strings.enrollmentNotAllowed;
          this.updateHeaderTotal();
          setTimeout(() => {
            const cartDrawer = document.querySelector('.cart__drawer');
            if (cartDrawer) {
              cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
            } else {
              console.error('Cart drawer element not found');
            }
          }, 600);
        })
        .catch(error => {
          console.error(error);
        });
       
    });
  }    

  isConsultant() {
    try {
      if (this.customer && this.customer.tags) {
        // Convert tags to array if it's a string
        const tags = Array.isArray(this.customer.tags) 
          ? this.customer.tags 
          : this.customer.tags.split(',').map(tag => tag.trim());
        
        return tags.includes('UserType_Consultant');
      }
      return false;
    } catch (error) {
      console.error('Error checking consultant status:', error);
      return false;
    }
  }
}

// Initialize on both DOMContentLoaded and section load
document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('[data-kit-selector]');
  if (section) {
    new KitSelector(section);
  }
});

